import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUserWorkouts, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { ALL_USER_WORKOUTS_GET, ASSIGN_FREE_WORKOUT_PLAN_CREATE, UNASSIGN_FREE_WORKOUT_PLAN_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useUserWorkouts = () => {
  const dispatch = useDispatch();
  const workouts = useSelector(state => state.workouts.all);

  useEffect(() => {
    if (workouts.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllUserWorkouts());
    }
  }, [dispatch, workouts.status]);

  useEffectOnSuccess([state => state.workoutPlans.assignFreeToUser, state => state.workoutPlans.unassignFreeFromUser], () => {
    dispatch(resetState(ALL_USER_WORKOUTS_GET));
    dispatch(resetState(ASSIGN_FREE_WORKOUT_PLAN_CREATE));
    dispatch(resetState(UNASSIGN_FREE_WORKOUT_PLAN_UPDATE));
  });

  return workouts;
};

export default useUserWorkouts;
